import Api from './index'
const baseUrl = '/v4/lesson-ratings'
export default {
	async getWithMembers(query) {
		let url = query
			? `${baseUrl}/with-members${query}`
			: `${baseUrl}/with-members`
		const res = await Api.get(url)
		return res.data
	},
	async getWithMembersAndTutorsAndPrograms(query) {
		let url = query
			? `${baseUrl}/with-members-and-tutors-and-programs${query}`
			: `${baseUrl}/with-members-and-tutors-and-programs`
		const res = await Api.get(url)
		return res.data
	},
	async getAverage({ tutorId, gteCreatedAt, lteCreatedAt }) {
		let query = ''
		if (tutorId) query = `${query}&tutor_id=${tutorId}`
		if (gteCreatedAt) query = `${query}&gte_created_at=${gteCreatedAt}`
		if (lteCreatedAt) query = `${query}&lte_created_at=${lteCreatedAt}`
		query = `?${query.substr(1)}`
		const res = await Api.get(`${baseUrl}/average${query}`)
		return res.data
	},
	async getByEncryptedId(encryptedMemberId, encryptedLessonId) {
		let url = `${baseUrl}/encrypted/member/${encryptedMemberId}/lesson/${encryptedLessonId}`

		const res = await Api.get(url)
		return res.data
	},
	async evaluate(encryptedMemberId, encryptedLessonId, params) {
		const res = await Api.post(
			`${baseUrl}/encrypted/member/${encryptedMemberId}/lesson/${encryptedLessonId}`,
			params,
		)
		return res.data
	},
}
